import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import bambooO from "../assets/bamboo-o.png";
import heroBg from "../assets/hero-bg.png";

function ProbwaLogoHero() {
  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center justify-center" style={{ letterSpacing: '0', lineHeight: 1 }}>
        <span 
          className="text-5xl md:text-7xl lg:text-8xl text-[#E8E8E8] font-bold"
          style={{ fontFamily: "'DM Serif Display', serif", letterSpacing: '-0.01em' }}
        >PR</span>
        <img 
          src={bambooO} 
          alt="O" 
          className="h-12 md:h-20 lg:h-24 w-auto inline-block"
          style={{ margin: '0 -6px', verticalAlign: 'middle' }}
        />
        <span 
          className="text-5xl md:text-7xl lg:text-8xl text-[#E8E8E8] font-bold"
          style={{ fontFamily: "'DM Serif Display', serif", letterSpacing: '-0.01em' }}
        >BWA</span>
      </div>
      <div className="flex items-center gap-3 mt-2">
        <div className="h-px w-10 bg-[#8BC34A]" />
        <span className="text-[#8BC34A] text-sm md:text-base tracking-[0.3em] font-light">
          ECO BOIS CONCEPT
        </span>
        <div className="h-px w-10 bg-[#8BC34A]" />
      </div>
    </div>
  );
}

export function Hero() {
  const scrollToProducts = () => {
    const element = document.querySelector("#products");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#2D2D2D]"
      data-testid="hero-section"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={heroBg}
          alt="Terrasse en bambou avec vue sur mer"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2D2D2D]/60 via-[#2D2D2D]/30 to-[#2D2D2D]/60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 text-center pt-20 md:pt-24">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="flex justify-center"
        >
          <ProbwaLogoHero />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-[#8BC34A] text-base md:text-lg font-medium tracking-wider uppercase mt-10 mb-6"
        >
          Votre spécialiste du bambou à La Réunion
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="text-2xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-[#E8E8E8] mb-8 md:mb-10 leading-tight"
          style={{ fontFamily: "'DM Serif Display', serif" }}
          data-testid="hero-title"
        >
          Sublimez vos espaces
          <br />
          <span className="text-[#8BC34A]">avec le bambou</span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Link
            to="/le-bambou"
            className="rounded-full px-6 py-3 md:px-8 md:py-4 text-sm md:text-lg font-bold tracking-wide min-w-[140px] md:min-w-[180px] text-center text-[#2D2D2D] hover:scale-105 transition-all duration-300"
            style={{
              background: 'linear-gradient(145deg, #e0e0e0, #a8a8a8)',
              boxShadow: 'inset 0 0 0 2px #8BC34A, inset 0 1px 3px rgba(255,255,255,0.6), inset 0 -1px 3px rgba(0,0,0,0.15), 0 4px 15px rgba(0,0,0,0.3)',
              border: '3px solid #b0b0b0',
            }}
            data-testid="hero-cta-bamboo"
          >
            En savoir +
          </Link>
          <Link
            to="/nos-produits"
            className="rounded-full px-6 py-3 md:px-8 md:py-4 text-sm md:text-lg font-bold tracking-wide min-w-[140px] md:min-w-[180px] text-center text-[#2D2D2D] hover:scale-105 transition-all duration-300"
            style={{
              background: 'linear-gradient(145deg, #e0e0e0, #a8a8a8)',
              boxShadow: 'inset 0 0 0 2px #8BC34A, inset 0 1px 3px rgba(255,255,255,0.6), inset 0 -1px 3px rgba(0,0,0,0.15), 0 4px 15px rgba(0,0,0,0.3)',
              border: '3px solid #b0b0b0',
            }}
            data-testid="hero-cta-products"
          >
            Nos produits
          </Link>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
      >
        <motion.button
          onClick={scrollToProducts}
          className="text-[#8BC34A] flex flex-col items-center gap-2 cursor-pointer"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          data-testid="scroll-indicator"
        >
          <span className="text-xs font-medium tracking-widest uppercase">Découvrir</span>
          <ChevronDown className="w-6 h-6" />
        </motion.button>
      </motion.div>
    </section>
  );
}
